import { FilterValuesObj } from '../../../../features/filter/interfaces';
import { FilterValueKey } from '../../../../features/filter/utils';
import { SolutionRequestProps } from '../../../../features/results/interfaces';
import { CalculationResultValues } from '../../types';

interface Props {
  values: FilterValuesObj;
}
export const getFlowrateRequest = ({ values }: Props): SolutionRequestProps => {
  const request: SolutionRequestProps = {
    calculationType: values[FilterValueKey.CALCULATION_RESULT] as CalculationResultValues,
    inputPressure: Number(values[FilterValueKey.SUPPLY_PRESSURE]),
    outputPressure: Number(values[FilterValueKey.OUTPUT_PRESSURE]),
    tubingLength: Number(values[FilterValueKey.TUBING_LENGTH]),
    internalDiameter: Number(values[FilterValueKey.INTERNAL_DIAMETER]),
    flowrate: Number(values[FilterValueKey.DISCHARGE]),
  };

  return request;
};
